import {ListPayments} from './list-payments';

export default ListPayments;
